const reg = /^(?:(?:31\.(?:0[13578]|1[02]))\.|(?:(?:29|30)\.(?:0[1,3-9]|1[0-2])\.))(?:\d{4})$|^(?:29\.02\.(?:19|20)(?:(?:0[48]|[2468][048]|[13579][26])|00))$|^(?:0[1-9]|1\d|2[0-8])\.(?:(?:0[1-9])|(?:1[0-2]))\.(?:\d{4})$/;

const iso = date => {
    if (!date) return '';
    const msOffset = date.getTimezoneOffset() * 60 * 1000;
    const newDate = new Date(date.getTime() - msOffset);
    return newDate.toISOString().slice(0, 10);
};

const str = date => date ? date.toLocaleDateString('ru-RU') : '';

const clearDate = date => new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);

const updateInput = (selectors, value) => {
    const input = document.querySelector(selectors);

    if (input) {
        if (input.value !== value) {
            input.value = value;
            input.dispatchEvent(new Event('blur', { bubbles: true })); // для валидатора
            input.dispatchEvent(new Event('change'));
        }
    }
};

$('input[name="calendar-start-date"]').mask('00.00.0000');
$('input[name="calendar-end-date"]').mask('00.00.0000');

document.addEventListener('click', function(event) {
    if (
        !event.target.closest('.js-calendar-wrap') &&
        !event.target.closest('.js-calendar-toggle-btn') &&
        !event.target.classList.contains('js-calendar-toggle-btn')
    ) {
        const calendarComponents = document.querySelectorAll('.js-calendar-component');
        if (calendarComponents) {
            calendarComponents.forEach(calendarComponent => {
                hideCalendar(calendarComponent);
            });
        }
    }
});

const allInputs = document.querySelectorAll('input, a, button, textarea');

allInputs.forEach(item => {
    item.addEventListener('focus', function(event) {
        if (!event.target.closest('.js-calendar-component')) {
            const calendarComponents = document.querySelectorAll('.js-calendar-component');
            if (calendarComponents) {
                calendarComponents.forEach(calendarComponent => {
                    hideCalendar(calendarComponent);
                });
            }
        }
    });
});

const calendarComponents = document.querySelectorAll('.js-calendar-component');

if (calendarComponents) {
    calendarComponents.forEach(calendarComponent => {
        calendarInit(calendarComponent);
    });
}

function calendarInit(calendarComponent) {
    generateCalendar(calendarComponent);

    const table = calendarComponent.querySelector('.js-calendar-table');

    calendarComponent.querySelector('.calendar__clear-btn').addEventListener('click', e => {
        table.dataset.startDate = '';
        table.dataset.endDate = '';
        updateInput('.js-calendar-start-date', '');
        updateInput('.js-calendar-end-date', '');
        updateChosenDays(calendarComponent);
        updateClearButtonVisibility(calendarComponent);

        const detail = { startDate: '', endDate: '', target: calendarComponent };
        const options = { detail, bubbles: true };
        calendarComponent.dispatchEvent(new CustomEvent('change', options));
    });

    const monthElement = calendarComponent.querySelector('.calendar__month');

    calendarComponent.querySelector('.calendar__prev-month').addEventListener('click', () => {
        const { year, month } = monthElement.dataset;
        const date = new Date(year, month - 1, 1);
        generateCalendar(calendarComponent, date);
    });

    calendarComponent.querySelector('.calendar__next-month').addEventListener('click', () => {
        const { year, month } = monthElement.dataset;
        const date = new Date(year, Number(month) + 1, 1);
        generateCalendar(calendarComponent, date);
    });

    calendarComponent.addEventListener('click', (event) => {
        // for days
        handleCalendarClick(event, calendarComponent);
    });

    calendarComponent.querySelectorAll('.calendar__close-btn').forEach(el => {
        el.addEventListener('click', () => {
            hideCalendar(calendarComponent);
        });
    });

    const startDateElement = calendarComponent.querySelector('.calendar__start-date');

    startDateElement.addEventListener('input', e => {
        const value = e.target.value;

        if (reg.test(value)) {
            const [day, month, year] = value.split('.');
            const date = new Date(year, month - 1, day);
            table.dataset.startDate = iso(date);
            generateCalendar(calendarComponent, date);
        }
        else {
            table.dataset.startDate = '';
        }

        updateChosenDays(calendarComponent);
        updateClearButtonVisibility(calendarComponent);
    });

    startDateElement.addEventListener('focus', e => {
        showInputErrorMessage(e.target);
    });

    startDateElement.addEventListener('blur', e => {
        hideInputErrorMessage(e.target);
        checkInputDate(e.target);
        checkEndDate(calendarComponent);
    });

    const endDateElement = calendarComponent.querySelector('.calendar__end-date');

    endDateElement.addEventListener('input', e => {
        const value = e.target.value;

        if (reg.test(value)) {
            const [day, month, year] = value.split('.');
            const date = new Date(year, month - 1, day);
            table.dataset.endDate = iso(date);
            generateCalendar(calendarComponent, date);
        }
        else {
            table.dataset.endDate = '';
        }

        updateChosenDays(calendarComponent);
        updateClearButtonVisibility(calendarComponent);
    });

    endDateElement.addEventListener('focus', e => {
        showInputErrorMessage(e.target);
    });

    endDateElement.addEventListener('blur', e => {
        hideInputErrorMessage(e.target);
        checkInputDate(e.target);
        checkEndDate(calendarComponent);
    });

    calendarComponent.querySelector('.calendar__ready-btn').addEventListener('click', () => {
        const inputs = calendarComponent.querySelectorAll('.calendar__input');

        if ([...inputs].some(el => el.classList.contains('has-error'))) return;

        const detail = { target: calendarComponent };
        const { startDate, endDate } = table.dataset;

        if (startDate) {
            detail.startDate = startDate;
        }

        if (endDate) {
            detail.endDate = endDate;
        }

        const options = { bubbles: true, detail };

        calendarComponent.dispatchEvent(new CustomEvent('change', options));

        hideCalendar(calendarComponent);
        updateToggler(calendarComponent);
    });

    const calendarTogglers = calendarComponent.querySelectorAll('.js-calendar-toggle-btn');

    calendarTogglers.forEach(btn => {
        btn.addEventListener('click', function () {
            toggleCalendar(calendarComponent);
        });
    });

    updateToggler(calendarComponent);
}

function updateToggler(calendarComponent) {
    const togglerElement = calendarComponent.querySelector('.js-calendar-toggle-btn');
    const formElement = calendarComponent.parentNode;

    if (!formElement.classList.contains('search-form')) return;

    const startDateElement = formElement.querySelector('.search-form__start-date');
    const endDateElement = formElement.querySelector('.search-form__end-date');

    if (!startDateElement) return;
    if (!endDateElement) return;

    const startDate = startDateElement.value ? clearDate(new Date(startDateElement.value)) : null;
    const endDate = endDateElement.value ? clearDate(new Date(endDateElement.value)) : null;

    if (startDate || endDate) {
        togglerElement.classList.add('has-value');
    }
    else {
        togglerElement.classList.remove('has-value');
    }
}

function updateChosenDays(calendarComponent) {
    const tableElement = calendarComponent.querySelector('.js-calendar-table');
    const startDate = tableElement.dataset.startDate ? clearDate(new Date(tableElement.dataset.startDate)) : null;
    const endDate = tableElement.dataset.endDate ? clearDate(new Date(tableElement.dataset.endDate)) : null;
    const days = calendarComponent.querySelectorAll('td');
    const weeks = calendarComponent.querySelectorAll('tbody tr');

    days.forEach((el, i) => {
        const { year, month, day } = el.dataset;
        const date = new Date(year, month, day, 0, 0, 0);

        if (
            ((startDate && endDate) && date >= startDate && date <= endDate) ||
            (startDate && date.getTime() === startDate.getTime()) ||
            (endDate && date.getTime() === endDate.getTime())
        ) {
            el.classList.add('calendar__day_chosen');
            i && days[i - 1].classList.add('calendar__day_before-chosen');
        }
        else {
            el.classList.remove('calendar__day_chosen');
            i && days[i - 1].classList.remove('calendar__day_before-chosen');
        }
    });

    weeks.forEach((el, i) => {
        const days = el.querySelectorAll('td');
        const chosen = [...days].some(el => el.classList.contains('calendar__day_chosen'));

        if (chosen) {
            el.classList.add('calendar__week_chosen');
            i && weeks[i - 1].classList.add('calendar__week_before-chosen');
        }
        else {
            el.classList.remove('calendar__week_chosen');
            i && weeks[i - 1].classList.remove('calendar__week_before-chosen');
        }
    });
}

function updateClearButtonVisibility(calendarComponent) {
    const el = calendarComponent.querySelector('.calendar__clear-btn');
    const startDate = calendarComponent.querySelector('.js-calendar-start-date');
    const endDate = calendarComponent.querySelector('.js-calendar-end-date');

    if (startDate.value || endDate.value) {
        el.classList.remove('hidden');
    }
    else {
        el.classList.add('hidden');
    }
}

function generateCalendar(calendarComponent, date) {
    const calendarElement = calendarComponent.querySelector('.js-calendar-table');
    const currentDate = new Date(calendarElement.dataset.startDate || calendarElement.dataset.currentDate || '');
    const displayedMonth = date ? date : new Date(new Date(currentDate).setDate(1));
    const firstDay = displayedMonth.getDay() ? displayedMonth.getDay() - 1 : 6; // 0 - это вс
    const prevMonth = new Date(new Date(displayedMonth).setMonth(displayedMonth.getMonth() - 1));
    const nextMonth = new Date(new Date(displayedMonth).setMonth(displayedMonth.getMonth() + 1));
    const daysNumber = new Date(new Date(nextMonth).setDate(0)).getDate();
    const weeksNumber = ((firstDay + daysNumber - 1) - (firstDay + daysNumber - 1) % 7) / 7;
    const prevMonthDaysNumber = new Date(new Date(displayedMonth).setDate(0)).getDate();
    const weeks = [];

    for (let w = 0; w <= weeksNumber; w++) {
        const weekElement = document.createElement('tr');
        weekElement.classList.add('calendar__week');

        for (let d = 0; d < 7; d++) {
            const i = (w * 7) + d;
            let day = i - firstDay + 1;
            let month = displayedMonth.getMonth();
            let year = displayedMonth.getFullYear();
            const isPrevMonth = i < firstDay;
            const isNextMonth = (firstDay + daysNumber - 1) < i;

            if (isPrevMonth) {
                day = prevMonthDaysNumber - (firstDay - i - 1);
                month = prevMonth.getMonth();
                year = prevMonth.getFullYear();
            }

            if (isNextMonth) {
                day = i - (firstDay + daysNumber - 1);
                month = nextMonth.getMonth();
                year = nextMonth.getFullYear();
            }

            const dayElement = document.createElement('td');
            dayElement.classList.add('calendar__day');
            dayElement.innerText = day.toString();

            (isPrevMonth || isNextMonth) && dayElement.classList.add('calendar__day_out');

            dayElement.dataset.day = day.toString();
            dayElement.dataset.month = month.toString();
            dayElement.dataset.year = year.toString();

            weekElement.appendChild(dayElement);
        }

        weeks.push(weekElement);
    }

    const tBodyElement = calendarElement.querySelector('tbody');

    if (tBodyElement) {
        tBodyElement.textContent = '';
        weeks.forEach(weekElement => tBodyElement.appendChild(weekElement));
    }

    updateChosenDays(calendarComponent);

    const monthElement = calendarComponent.querySelector('.calendar__month');
    monthElement.dataset.month = displayedMonth.getMonth().toString();
    monthElement.dataset.year = displayedMonth.getFullYear().toString();
    monthElement.innerText = displayedMonth.toLocaleString('ru-RU', { year: 'numeric', month: 'long' }).slice(0, -3);

    const tableElement = calendarComponent.querySelector('.js-calendar-table');
    const { startDate, endDate } = tableElement.dataset;
    updateInput('.js-calendar-start-date', str(startDate ? new Date(startDate) : ''));
    updateInput('.js-calendar-end-date', str(endDate ? new Date(endDate) : ''));

    updateClearButtonVisibility(calendarComponent);
}

function handleCalendarClick(event, calendarComponent) {
    const target = event.target;
    let { year, month, day } = target.dataset;
    const table = calendarComponent.querySelector('.js-calendar-table');

    if (target.tagName === 'TD' && !target.classList.contains('calendar__disabled-day')) {
        const mode = calendarComponent.querySelector('.js-calendar-table').dataset.mode;
        const startDate = calendarComponent.querySelector('.js-calendar-table').dataset.startDate;
        const endDate = calendarComponent.querySelector('.js-calendar-table').dataset.endDate;
        let newStartDate;
        let newEndDate;

        const selectedDate = new Date(Number(year), Number(month), Number(day), 0, 0, 0);
        const oldStartDate = newStartDate = startDate ? clearDate(new Date(startDate)) : null;
        const oldEndDate = newEndDate = endDate ? clearDate(new Date(endDate)) : null;
        day = day > 9 ? day : '0' + day;
        month = month > 9 ? month : '0' + month;

        if (mode === 'range') {
            if ((oldStartDate && !oldEndDate) && (selectedDate > oldStartDate)) {
                newEndDate = selectedDate;
            }
            else {
                newStartDate = selectedDate;
                newEndDate = null;
            }

            if (oldStartDate !== newStartDate) {
                table.dataset.startDate = iso(newStartDate);
                updateInput('.js-calendar-start-date', str(newStartDate));
            }

            if (oldEndDate !== newEndDate) {
                table.dataset.endDate = iso(newEndDate);
                updateInput('.js-calendar-end-date', str(newEndDate));
            }

            if (oldStartDate !== newStartDate || oldEndDate !== newEndDate) {
                updateChosenDays(calendarComponent);
                updateClearButtonVisibility(calendarComponent);
            }
        }
        else {
            if (calendarComponent.querySelector('.calendar-input_hidden')) {
                calendarComponent.querySelector('.calendar-input_hidden').value = year + '-' + month + '-' + day; // в формате yyyy-mm-dd
                let calendarInputHiddenEvent = new Event('change');
                calendarComponent.querySelector('.calendar-input_hidden').dispatchEvent(calendarInputHiddenEvent);
            }

            if (calendarComponent.querySelector('.calendar__chosen-day')) {
                calendarComponent.querySelector('.calendar__chosen-day').classList.remove('calendar__chosen-day');
            }

            target.classList.add('calendar__chosen-day');
        }

        const event = new CustomEvent('calendarSelectDay', {
            'detail': {
                date: year + '-' + month + '-' + day,
                form: calendarComponent.closest('form'),
                calendarComponent: calendarComponent,
            },
        });
        document.dispatchEvent(event);
    }
}

function hideCalendar(calendar) {
    calendar.querySelector('.js-calendar-wrap').classList.add('hidden');
    calendar.querySelector('.js-calendar-toggle-btn').classList.remove('active');

    const event = new Event('calendarClose');
    document.dispatchEvent(event);
}

function openCalendar(calendar) {
    const parent = calendar.parentNode;

    if (parent.classList.contains('search-form')) {
        const tableElement = calendar.querySelector('.js-calendar-table');
        const startDateInput = parent.querySelector('.search-form__start-date');
        const endDateInput = parent.querySelector('.search-form__end-date');

        if (startDateInput) {
            tableElement.dataset.startDate = startDateInput.value || '';
        }

        if (endDateInput) {
            tableElement.dataset.endDate = endDateInput.value || '';
        }
    }

    generateCalendar(calendar);

    calendar.querySelector('.js-calendar-wrap').classList.remove('hidden');
    calendar.querySelector('.js-calendar-toggle-btn').classList.add('active');
}

function toggleCalendar(calendar) {
    if (calendar.querySelector('.js-calendar-toggle-btn').classList.contains('active')) {
        hideCalendar(calendar);
    }
    else {
        openCalendar(calendar);
    }
}

function checkInputDate(el) {
    const value = el.value;
    const valid = value ? reg.test(value) : true;

    if (valid) {
        el.classList.remove('has-error');
    }
    else {
        el.classList.add('has-error');
        el.dataset.errorMessage = 'Формат: ДД.ММ.ГГГГ';
    }
}

function checkEndDate(calendarComponent) {
    const startDateElement = calendarComponent.querySelector('.js-validation-start-date');
    const endDateElement = calendarComponent.querySelector('.js-validation-end-date');

    if (!startDateElement) return;

    const valid = str => /(\d{2}).(\d{2}).(\d{4})/.test(str);
    const startDateStr = startDateElement.value;
    const endDateStr = endDateElement.value;

    if (!valid(startDateStr) || !valid(endDateStr)) return;

    const toDate = str => {
        const [day, month, year] = str.split('.');
        return new Date(Number(year), month - 1, Number(day), 0, 0, 0);
    };

    if (toDate(startDateStr) > toDate(endDateStr)) {
        endDateElement.classList.add('has-error');
        endDateElement.dataset.errorMessage = 'Дата не может быть меньше ' + startDateStr;
    }
    else {
        endDateElement.classList.remove('has-error');
    }
}

function hideInputErrorMessage(el) {
    const parent = el.parentNode;
    const hint = parent.querySelector('.hint');
    if (hint) parent.removeChild(hint);
}

function showInputErrorMessage(el) {
    const message = el.dataset.errorMessage;

    if (!message) return;

    const hintText = document.createElement('div');
    hintText.classList.add('hint__text');
    hintText.innerText = message;

    const hint = document.createElement('div');
    hint.classList.add('hint');
    hint.classList.add('hint_error');
    hint.classList.add('hint_visible');
    hint.appendChild(hintText);

    const parent = el.parentNode;
    const child = parent.querySelector('.hint');

    if (child) parent.removeChild(child);

    parent.appendChild(hint);
}